import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdLock, MdLogin, MdMessage, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked, MdWhatsapp } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import {
  STR_APP_NAME,
  STR_CHANGE_LANGUAGE,
  STR_CHANGE_PHONE,
  STR_CONFIRM,
  STR_CONTINUE,
  STR_ENTER,
  STR_ENTER_OTP,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_FORGOT_PASSWORD,
  STR_GET_STARTED,
  STR_HEALTH,
  STR_INTRO_1,
  STR_INTRO_2,
  STR_INVALID_CONFIRM_PASSWORD,
  STR_INVALID_OTP,
  STR_INVALID_PASSWORD,
  STR_INVALID_PHONE,
  STR_PASSWORD,
  STR_PLEASE_WAIT,
  STR_RELATIONSHIPS,
  STR_RESEND_OTP,
  STR_STORIES,
  STR_WELCOME
} from "../Strings";
import logo from "../assets/logo.png";
import OneHotelFeed from '../ones/OneHotelFeed';
import DivsSlider from "../ones/DivsSlider";
import LoginView from '../views/LoginView'

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loginStep, setLoginStep] = useState("launch");

  async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getHotelsFeed(),
			appContext.getAllHotelAttributes(),
		]);
		setReady(true);
	}

  async function getStarted(e) {

    if(e) {
      e.stopPropagation();
    }

    appContext.navTo({
      item: 'view',
      subItem: 'login',
    })

    
  }
  

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  return (
    <LoginView/>
  )

  return (
    <div
      className="Login"
    >
      {
        (loginStep === 'launch') ?
          <div
            className="launch mNoScrollBar"
          >

            <div className="container">

              <div className="row">
                
                
                <div
                  className="col-md-6"
                  style={{
                    paddingTop: "20px"
                  }}
                >
                  <div className="card">
                    <div className="card-body" style={{ height: "300px" }}>
                      
                      <div className="text-center">
                        <img
                          src={logo}
                          width="120px"
                          height="auto"
                        />
                      </div>
                      <h6
                        className="font-bold text-dark text-center mt-4"
                      >
                        
                        <span
                          style={{
                            width: "auto",
                            padding: "6px",
                            borderRadius: "10px",
                            fontSize: "20px",
                            border: "3px solid var(--primaryColor)"
                          }}
                          className=""
                        >
                          AVAN HOTELS
                        </span>
                      </h6>

                      <h6
                        style={{
                          fontSize: "18px",
                        }}
                        className="font-regular mb-4 mt-4 text-center"
                      >
                        {STR_INTRO_2[appContext.language]}
                      </h6>

                      <h6
                        className="text-center font-bold mt-3"
                      >
                        &copy; ATAN Global (T) LTD
                      </h6>
                      
                    </div>
                  </div>
                </div>                
                
                {
                  (ready && appContext.hotelsFeed && appContext.hotelsFeed.length > 0) ?
                  <div 
                    className="col-md-6"
                    style={{
                      paddingTop: "20px"
                    }}
                  >
                    <div 
                      id="hotelCarousel" 
                      className="carousel slide" 
                      data-bs-ride="carousel" 
                      data-bs-interval="3000"  // Auto scroll every 3 seconds (3000ms)
                    >
                      <div className="carousel-inner">
                        {
                          appContext.hotelsFeed.map((item, i) => {
                            item.distance = null;

                            if(i === 0) {
                              
                              
                              setTimeout(() => {
                                try {
                                  document.getElementById('_sliderTrigger').click();
                                } catch (error) {
                                  
                                }
                              }, 3000)
                              
                            }

                            return (
                              <div onClick={getStarted} key={i} className={`carousel-item ${i === 0 ? 'active' : ''}`}>
                                <OneHotelFeed unClickable={true} data={item} />
                              </div>
                            );
                          })
                        }
                      </div>
                      
                      {/* Carousel Controls */}
                      <button className="carousel-control-prev" type="button" data-bs-target="#hotelCarousel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button id="_sliderTrigger" className="carousel-control-next" type="button" data-bs-target="#hotelCarousel" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                  : ""
                }

                <div
                  className="col-md-12"
                  style={{
                    paddingTop: "20px"
                  }}
                >
                  

                  <div className="row">
                    <div className="col-6">
                      <button
                        className="btn btn-padded btn-block btn-dark btn-rounded"
                        style={{
                          textTransform: "capitalize",
                          fontSize: "14px",
                        }}
                        onClick={() => getStarted()}
                      >
                        {STR_GET_STARTED[appContext.language]}
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        className="btn btn-padded btn-block bg-background btn-rounded"
                        style={{
                          textTransform: "capitalize",
                          fontSize: "14px",
                        }}
                        onClick={() => appContext.changeLanguage()}
                      >
                        {(appContext.language === 'en') ? "Use Swahili" : "Use English"}
                      </button>
                    </div>
                  </div>
                  

                </div>
                
              </div>
            </div>

          </div>
          : ""
      }


    </div >
  )
}